// extracted by mini-css-extract-plugin
export default {"row":"СlientsSelect_row__0b36v","fieldLabel":"СlientsSelect_fieldLabel__riEL7"};